/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/ExecutionFooter.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Sticky footer for execution actions.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Save Progress
 * ✓ Complete Work
 * ✓ Display Last Saved Information
 *
 ******************************************************************************/

import React from "react";

export default function ExecutionFooter({

    lastSaved,

    saving = false,

    completing = false,

    disabled = false,

    onSave,

    onComplete,

}) {

    return (

        <div

            className="card shadow border-0"

            style={{

                position: "sticky",

                bottom: 0,

                zIndex: 1000,

                borderRadius: 0,

            }}

        >

            <div className="card-body">

                <div className="row align-items-center">

                    {/* ====================================================== */}
                    {/* LAST SAVED */}
                    {/* ====================================================== */}

                    <div className="col-md-6">

                        <small className="text-muted">

                            <i className="fas fa-save me-2" />

                            Last Saved :

                            {" "}

                            {lastSaved || "Not Saved"}

                        </small>

                    </div>

                    {/* ====================================================== */}
                    {/* ACTIONS */}
                    {/* ====================================================== */}

                    <div className="col-md-6 text-md-end mt-3 mt-md-0">

                        <button

                            type="button"

                            className="btn btn-outline-primary me-2"

                            disabled={disabled || saving}

                            onClick={onSave}

                        >

                            {

                                saving

                                    ? (

                                        <>

                                            <span

                                                className="spinner-border spinner-border-sm me-2"

                                            />

                                            Saving...

                                        </>

                                    )

                                    : (

                                        <>

                                            <i className="fas fa-save me-2" />

                                            Save Progress

                                        </>

                                    )

                            }

                        </button>

                        <button

                            type="button"

                            className="btn btn-success"

                            disabled={disabled || completing}

                            onClick={onComplete}

                        >

                            {

                                completing

                                    ? (

                                        <>

                                            <span

                                                className="spinner-border spinner-border-sm me-2"

                                            />

                                            Completing...

                                        </>

                                    )

                                    : (

                                        <>

                                            <i className="fas fa-check me-2" />

                                            Complete Work

                                        </>

                                    )

                            }

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

}